import styled from 'styled-components';
import { config } from '../../../../Configurations';

export const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
`;

// Middle container
export const RoomsContainer = styled.div`
    width: calc(100% - 340px);
    max-height: 100%;
    overflow: auto;
    padding: 12px;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
`;

export const CardContainer = styled.div`
    padding: 8px;
    width: 240px;
    height: 200px;
    flex-basis: 33%;
    -ms-flex: auto;
    margin-bottom: 10px;
    position: relative;

    @media (max-width: 1175px) {
        flex-basis: 50%;
    }
`;

export const EmptyCardContainer = styled.div`
    width: 100%;
    height: 160px;
    border-radius: 10px;
    border: dashed 1px #979797;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CardHeader = styled.div`
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
`;

export const CardHeaderContent = styled.div`
    max-width: calc(100% - 35px);
    margin-right: 8px;
`;

export const CardBody = styled.div`
    width: 100%;
    height: 160px;
    border-radius: 10px;
    border: solid 3px rgba(255, 255, 255, 0.5);
    background-image: ${props =>
        props.background
            ? `url(${config.baseUrl}/${props.background})`
            : 'radial-gradient(circle at 48% 3%, #fb721b, #fd3260)'};
    background-size: cover;

    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 998;

    cursor: pointer;

    &:hover {
        opacity: 0.85;
    }

    transition: all 0.25s;
`;

export const PlayButton = styled.button`
    width: 60px;
    height: 23px;
    background-color: white;
    border: none;
    border-radius: 100px;
    outline: none;
    cursor: pointer;
    height: 23px;
    color: #fb4a52;
    font-size: 10px;
    text-transform: uppercase;
    transition: all 0.2s ease;
    z-index: 999;

    // &:hover {
    //     opacity: 0.75;
    // }
`;

// Container for settings
export const SettingsContainer = styled.div`
    width: 340px;
    height: 100%;
    overflow: auto;
    background-color: #121212;
    padding: 5px 20px;
`;

export const FakeCheckBox = styled.div`
    width: 18px;
    height: 18px;
    border-radius: 2px;
    background-color: rgba(239, 240, 242, 0.18);
`;

export const DarkButton = styled.button`
    width: 60px;
    height: 23px;
    background-color: rgba(239, 240, 242, 0.18);
    border: none;
    border-radius: 100px;
    outline: none;
    cursor: pointer;
    height: 23px;
    color: white;
    font-size: 10px;
    text-transform: uppercase;
    transition: all 0.2s ease;

    &:hover {
        opacity: 0.75;
    }
`;

export const Input = styled.input`
    width: 100%;
    height: 30px;
    border-radius: 2px;
    background-color: rgba(239, 240, 242, 0.18);
    border: none;
    padding-left: 15px;
    color: white;
    outline: none;

    &:placeholder {
        opacity: 0.5;
    }
`;

export const Select = styled.select`
    width: 100%;
    height: 30px;
    border-radius: 2px;
    background-color: rgba(239, 240, 242, 0.18);
    border: none;
    padding-left: 15px;
    color: white;
    outline: none;

    &:placeholder {
        opacity: 0.5;
    }
`;

export const InputLabel = styled.p`
    font-size: 12px;
    font-family: Rubik;
    margin-bottom: 6px;
    font-weight: bold;
    color: #c5cacf;
`;

export const CardNameInput = styled.input`
    background-color: #0e0e0e;
    width: 100%;
    font-weight: 800;
    font-size: 22px;
    border: none;
    color: white;
`;

// Settings preview item
export const PreviewContainer = styled.div`
    width: 100%;
    display: flex;
`;

export const PreviewImage = styled.div`
    width: 125px;
    height: 77px;
    background-image: url(${props => (props.background ? props.background : null)});
    background-size: 100% 81px;
    background-repeat: no-repeat;
    border-radius: 7px;
    position: relative;
    cursor: pointer;
    overflow: hidden;

    &:hover {
        & div {
            transform: translateX(0);
        }
    }
`;

export const PreviewImageOverlay = styled.div`
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    position: absolute;
    top: 0;
    left: 0;
    transform: translateX(-100%);
    border-radius: 7px;
    transition: all 0.25s;
    cursor: default;
    padding: 0 20px;

    display: flex;
    justify-content: space-around;
    align-items: center;
`;

export const PreviewActions = styled.div`
    width: 50%;
    padding-left: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const EmptyPreview = styled.div`
    width: 50%;
    height: 70px;
    border-radius: 7px;
    background-color: #39393a
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const ChannelBackgroundPreviewZone = styled.div`
    width: 100%;
    height: 160px;
    border-radius: 10px;
    background-image: url(${props => (props.background ? props.background : null)});
    background-size: cover;
    position: relative;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const ImageButton = styled.label`
    border: none;
    border-radius: 100px;
    background-color: rgba(239, 240, 242, 0.18);
    padding: 6px 10px;
    text-transform: uppercase;
    color: white;
    font-size: 10px;
    z-index: 1000;

    &:hover {
        opacity: 0.75;
    }

    transition: all 0.25s;
    cursor: pointer;
    outline: none;
`;

export const DarkInputButton = styled.label`
    width: 60px;
    height: 23px;
    padding: 6px 10px;
    background-color: rgba(239, 240, 242, 0.18);
    border: none;
    border-radius: 100px;
    outline: none;
    cursor: pointer;
    height: 23px;
    color: white;
    font-size: 10px;
    text-transform: uppercase;
    transition: all 0.2s ease;

    &:hover {
        opacity: 0.75;
    }
`;

export const KebabContainer = styled.div`
    position: absolute;
    top: 55px;
    right: 25px;
    z-index: 1000;
`;

export const CheckboxLabel = styled.label`
    color: #c5cacf;
    margin-left: 10px;
    font-weight: 100;
    font-size: 12px;
`;

export const DarkeningLayer = styled.div`
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 7px;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/GymTv/style.js